import React from 'react';
import { isMobile } from 'react-device-detect';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import fiberInfrastructureLoaderDesktop from './Animation/Loader_Sivim.json';
import fiberInfrastructureLoaderMobile from './Animation/Loader_Mobile.json';
import './internetCheckFiberStatus.scss';

const InternetCheckFiberStatus = (props) => {
  const getAddressLine = () => {
    const { selectedAddress } = props;
    if (!selectedAddress?.streetName) {
      return '';
    }
    return `${selectedAddress.streetName} ${selectedAddress.home}, ${selectedAddress.cityName}`;
  };

  return (
    <div className='internet-check-fiber-status'>
      <div className='internet-check-fiber-status__content'>
        <h1 className='internet-check-fiber-status__title'>אנחנו בודקים, כבר איתך</h1>
        {getAddressLine() && <p className='internet-check-fiber-status__subtitle'>{getAddressLine()}</p>}
      </div>
      <div className={`internet-check-fiber-status__illustration${isMobile ? ' is-mobile' : ''}`}>
        <ThemedLottie
          animationData={isMobile ? fiberInfrastructureLoaderMobile : fiberInfrastructureLoaderDesktop}
          loop={true}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: isMobile ? 'xMidYMid slice' : 'xMidYMid meet',
          }}
        />
      </div>
    </div>
  );
};

export default InternetCheckFiberStatus;
